import { Validator } from 'fluentvalidation-ts';
import { beAnInteger, bePositiveNumber } from '../../validators/stringValidators';
import { BillOfMaterialsOptionalExtraResponse, BillOfMaterialsPartsById } from './dataForEditBillOfMaterialsForm';

export type BillOfMaterialsOptionalExtraFormModel = {
  billOfMaterialsOptionalExtraId: number | null;
  partId: number;
  quantity: string;
  partIsInactiveValidation: null; // Placeholder property
};

export const mapBillOfMaterialsOptionalExtraToFormModel = (
  billOfMaterialsOption: BillOfMaterialsOptionalExtraResponse,
): BillOfMaterialsOptionalExtraFormModel => ({
  billOfMaterialsOptionalExtraId: billOfMaterialsOption.billOfMaterialsOptionalExtraId,
  partId: billOfMaterialsOption.partId,
  quantity: billOfMaterialsOption.quantity.toString(),
  partIsInactiveValidation: null,
});

export class BillOfMaterialsOptionalExtraFormModelValidator extends Validator<BillOfMaterialsOptionalExtraFormModel> {
  constructor(partsById: BillOfMaterialsPartsById) {
    super();

    this.ruleFor('quantity')
      .notEmpty()
      .must(beAnInteger)
      .must(bePositiveNumber);

    this.ruleFor('partIsInactiveValidation')
      .must((_, extra) => extra.partId == null || !partsById[extra.partId].isInactive)
      .withMessage('This Part is marked as inactive');
  }
}
